export default __webpack_public_path__ + "static/media/home_icon.a1307e7a.svg";